import { render, staticRenderFns } from "./fee-fixo-guia-simulacao-card.vue?vue&type=template&id=88045fda&scoped=true&"
import script from "./fee-fixo-guia-simulacao-card.vue?vue&type=script&lang=js&"
export * from "./fee-fixo-guia-simulacao-card.vue?vue&type=script&lang=js&"
import style0 from "./fee-fixo-guia-simulacao-card.vue?vue&type=style&index=0&id=88045fda&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88045fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88045fda')) {
      api.createRecord('88045fda', component.options)
    } else {
      api.reload('88045fda', component.options)
    }
    module.hot.accept("./fee-fixo-guia-simulacao-card.vue?vue&type=template&id=88045fda&scoped=true&", function () {
      api.rerender('88045fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fee-fixo/components/fee-fixo-guia-simulacao-card/fee-fixo-guia-simulacao-card.vue"
export default component.exports